import AdministratorsApi from '../../../../core/api/AdministratorsApi'
const api = new AdministratorsApi()

export const events = {
  load: {
    fetching: 'FETCHING_ADMINISTRATORS',
    fetched: 'FETCHED_ADMINISTRATORS'
  },
  setting: {
    toggleAdministratorActive: 'ADMINISTRATORS_TOGGLE_ACTIVE'
  },
  submitting: {
    administrator: 'ADMINISTRATORS_SUBMITTING'
  },
  submitted: {
    administrator: 'ADMINISTRATORS_SUBMITTED'
  }
}

export const actions = {
  load: {
    fetchingAdministrators: () => ({
      type: events.load.fetching
    }),
    fetchAdministrators: () => {
      const administratorsRequest = api.getAdministrators()

      return (dispatch) => {
        dispatch({ type: events.load.fetching })
        administratorsRequest.then(function (response) {
          dispatch(api.handleResponse(events.load.fetched, response))
        })
      }
    }
  },
  setting: {
    toggleAdministratorActive: (index) => ({
      type: events.setting.toggleAdministratorActive,
      index
    })
  },
  submit: {
    submitAdministratorActive: (administrator) => {
      const administratorRequest = api.setAdministratorActive(administrator)

      return (dispatch) => {
        dispatch({type: events.submitting.administrator})
        administratorRequest.then(function (response) {
          dispatch(api.handleResponse(events.submitted.administrator, response))
        })
      }
    }
  }
}
